import {
  createSearchAndFilterDisplayOptions,
  getDefaultRequestFields,
  mapLoyaltyEducation,
  mapOmnitureData,
  mapPropertySearchMessage,
  mapPropertySearchResults,
  mapSearchedDestination,
  mapSortAndFilter,
  SearchMigrationAdapter
} from 'stores/adapters';
import { mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';

import { HotelResultsViewModel } from 'models';

import { FullPropertySearch, OperationResult } from '__generated__/api';

export const adaptFullPropertySearch: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<FullPropertySearch.Query>
): HotelResultsViewModel => {
  const { data, extensions } = bexApiResults;

  const { propertySearch } = data;

  if (!propertySearch) {
    return bffResults;
  }

  const { summary } = propertySearch;

  const loyaltyInfo = summary && summary.loyaltyInfo;

  return {
    ...bffResults,
    sortAndFilter: mapSortAndFilter(data.propertySearch),
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(),
    hotels: mapPropertySearchResults(data),
    messages: mapPropertySearchMessage(data),
    searchedDestination: mapSearchedDestination(data),
    summaryMessages: summary && summary.resultsSummary,
    totalPropertyCount: summary && summary.matchedPropertiesSize,
    defaultRequestFields: getDefaultRequestFields(
      data.propertySearch.searchCriteria,
      summary && summary.region,
      data.propertySearch.shoppingContext &&
        data.propertySearch.shoppingContext.multiItem &&
        data.propertySearch.shoppingContext.multiItem.id
    ),
    omnitureData: mapOmnitureData(extensions.analytics),
    map: mapMap(data),
    loyaltyEducation: mapLoyaltyEducation(data),
    loyaltyMessagingModel: loyaltyInfo && {
      loyaltyPointsMessage: loyaltyInfo.saveWithPointsMessage,
      swpActionMessage: loyaltyInfo.saveWithPointsActionMessage
    }
  };
};
